module.exports = "/_next/static/images/91ed06ea587a27a23951754c4cb8645c-slide1mobile.jpg";